import penceToPound from './penceToPound';

const getRecommendedTariffValues = (recommendedTariff) => {
  if (!recommendedTariff) return { exportValue: 0, importValue: 0 };
  const exportValue = penceToPound(recommendedTariff.optimised_tariff_results.export_cost, true);
  const importValue = penceToPound(recommendedTariff.optimised_tariff_results.import_cost, true);
  return { exportValue, importValue };
};

export default getRecommendedTariffValues;
